




































/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { getActionName, ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import NewWebsiteForm from "@/Ui-Components/Domain/NewWebsiteForm.vue";
import ContentStreamForm from "@/Ui-Components/ContentStream/ContentStreamForm.vue";
import { IDomainService } from "../../BusinessServices/domain";
import { CustomerUrlModel, NewWebsiteDTO, ContentStreamDTO, ContentStreamBillingConfigurationDTO } from "../../Generated/ParticaAPI";
import { IContentStreamService } from "../../BusinessServices/contentstream";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ContentStreamCreate from "@/Ui-Components/ContentStream/ContentStreamCreate.vue";

@Component(
	{
		name: "Administration",
		components: {
			ParticaRowContainer,
			ParticaCard,
			ContentStreamForm,
			NewWebsiteForm,
			ParticaDialogCard,
			ParticaView,
			ParticaRightDrawer,
			ContentStreamCreate
		}
	})
export default class Administration extends ParticaAdminBase {
	private showcsdialog: boolean = false;
	private showstreamcreate: boolean = false;
	private stream: ContentStreamDTO = new ContentStreamDTO();

	private buttons: ButtonConfig[] = [
		{
			label: "Save Content Stream",
			action: eParticaAction.CONTENT_STREAM_SAVE,
			type: ButtonType.OK
		} as ButtonConfig,
		{
			label: "Cancel",
			action: eParticaAction.CONTENT_STREAM_SAVE_CANCEL,
			type: ButtonType.Cancel
		} as ButtonConfig
	];

	private shownewwebsitedialog: boolean = false;
	private newsitemodel: NewWebsiteDTO = new NewWebsiteDTO();
	private newsitebuttons: ButtonConfig[] = [
		{
			label: "Add Website",
			action: eParticaAction.WEBSITE_SAVE,
			type: ButtonType.OK
		} as ButtonConfig,
		{
			label: "Cancel",
			action: eParticaAction.WEBSITE_CANCEL_SAVE,
			type: ButtonType.Cancel
		} as ButtonConfig
	];
	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_SAVE: {
					this.stream.customerAccountId = this.stateconfig.accountid;
					const contentStreamService: IContentStreamService = this.particaServices.getContentStreamService();
					this.stream = await contentStreamService.saveContentStream(this.stream);
					this.trackEvent("CONTENT_STREAM_CREATE", this.stream);
					this.ShowSnackbar(this.stream.name + " created.");
					this.ReloadMenu("cs:" + this.stream.id);
					this.showstreamcreate = false;
					break;
				}
				/*case eParticaAction.CONTENT_STREAM_SAVE: {
					this.showcsdialog = false;
					this.stream.customerAccountId = this.stateconfig.accountid;
					const contentStreamService: IContentStreamService = this.particaServices.getContentStreamService();
					this.stream = await contentStreamService.saveContentStream(this.stream);
					this.trackEvent("CONTENT_STREAM_CREATE", this.stream);
					this.ShowSnackbar(this.stream.name + " created.");
					this.ReloadMenu("cs:" + this.stream.id);
					break;
				}*/
				case eParticaAction.CONTENT_STREAM_SAVE_CANCEL: {
					this.stream = new ContentStreamDTO();
					this.showcsdialog = false;
					break;
				}
				case eParticaAction.WEBSITE_SAVE: {
					this.newsitemodel.customerAccountId = this.stateconfig.accountid;
					const domainService: IDomainService = this.particaServices.getDomainService();
					const url: CustomerUrlModel = await domainService.addNewWebsite(this.newsitemodel);
					this.ShowSnackbar(url.url + " created.");
					this.shownewwebsitedialog = false;
					this.ReloadMenu("site:" + url.id);
					this.newsitemodel = new NewWebsiteDTO();
					break;
				}
				case eParticaAction.WEBSITE_CANCEL_SAVE: {
					this.shownewwebsitedialog = false;
					this.newsitemodel = new NewWebsiteDTO();
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}
	private async mounted() {
		this.metadata.name = "Administrator only functions";
		this.stream.contentStreamBillingConfigurations = [];
		this.stream.contentStreamBillingConfigurations.push(new ContentStreamBillingConfigurationDTO());
		await this.getAdminNav(0);
	}


}
